import React, { useContext, useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Box,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import WarningIcon from "@material-ui/icons/Warning";
import LayersIcon from "@material-ui/icons/Layers";
import { Button } from "../ui/forms/Button";
import { SubHeading } from "../ui/SubHeading";
import { UserContext } from "../../contexts/UserContext";
import { OrderContext } from "../../contexts/OrderContext";
import { PatronContext } from "../../contexts/PatronContext";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import { Checkbox } from "../ui/forms/Checkbox";

const BulkActions = ({ open, close }) => {
  const [patrons, setPatrons] = useState([]);
  const [yearGroup, setYearGroup] = useState(0);
  const { Site } = useContext(UserContext);
  const { photoRequired, siteType } = Site;
  const {
    getAllPatrons,
    deleteAllPatrons,
    incrementPatronYearGroup,
    FirstTimeOrderYear,
    refreshPatrons,
    incrementPatronYearGroupAndRemove,
  } = useContext(PatronContext);
  const { addPatronsToOrder, clearOrders, FirstTimeOrderQueue } =
    useContext(OrderContext);
  const [FirstTimeOrder, setFirstTimeOrder] = React.useState(true);

  const patronLabel = Site.siteType === 0 ? "students" : "staff";

  const [deleteModal, setDeleteModal] = useState(false);
  const [IncModal, setIncModal] = useState(false);

  const getPatronsByYear = async (e) => {
    const year = e.target.value;
    setYearGroup(year);
    let results = [];

    //handle if only first orders
    if (FirstTimeOrder === true) {
      const allPatrons = await FirstTimeOrderYear(year);
      allPatrons.forEach((patron) => {
        results.push(patron);
      });
    } else {
      const allPatrons = await getAllPatrons();

      allPatrons.forEach((patron) => {
        if (patron.yearGroup === year) results.push(patron);
      });
    }

    setPatrons(results);
    //eslint-disable-next-line
  };

  const queueAllPatrons = async () => {
    let results = [];

    if (FirstTimeOrder === true) {
      results = await FirstTimeOrderQueue();
    } else {
      results = await getAllPatrons();
    }

    addPatronsToOrder(results);
    close();
  };

  const increment = async () => {
    incrementPatronYearGroup();
    close();
  };

  const incrementAndRemove = async (Dlt) => {
    incrementPatronYearGroupAndRemove(Dlt);
    close();
  };

  useEffect(() => {
    //getPatronsByYear({ target: { value: -1 } });
    //eslint-disable-next-line
  }, []);

  return (
    <Dialog
      open={open}
      onClose={close}
      maxWidth={Site.siteType === 0 || Site.siteType === 5 ? "md" : "sm"}
    >
      <Container>
        <Grid container spacing={2}>
          {Site.siteType === 0 || Site.siteType === 5 ? (
            <Grid item xs={12} md={4}>
              <SubHeading>
                {" "}
                <AddIcon style={iconStyles} /> Queue By Year
              </SubHeading>
              <StyledButton
                onClick={() => {
                  addPatronsToOrder(patrons);
                  close();
                  setYearGroup(0);
                }}
                colour="success"
              >
                Queue year {yearGroup}
              </StyledButton>

              <FormControl>
                <Select
                  name="yearGroup"
                  value={yearGroup}
                  onChange={getPatronsByYear}
                >
                  <MenuItem value={0}>None</MenuItem>
                  <MenuItem value={15}>Pre-Kindy</MenuItem>
                  <MenuItem value={13}>Kindergarten</MenuItem>
                  <MenuItem value={14}>Pre-Primary</MenuItem>
                  <MenuItem value={1}>Year 1</MenuItem>
                  <MenuItem value={2}>Year 2</MenuItem>
                  <MenuItem value={3}>Year 3</MenuItem>
                  <MenuItem value={4}>Year 4</MenuItem>
                  <MenuItem value={5}>Year 5</MenuItem>
                  <MenuItem value={6}>Year 6</MenuItem>
                  <MenuItem value={7}>Year 7</MenuItem>
                  <MenuItem value={8}>Year 8</MenuItem>
                  <MenuItem value={9}>Year 9</MenuItem>
                  <MenuItem value={10}>Year 10</MenuItem>
                  <MenuItem value={11}>Year 11</MenuItem>
                  <MenuItem value={12}>Year 12</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          ) : (
            <></>
          )}

          <Grid
            item
            xs={12}
            md={Site.siteType === 0 || Site.siteType === 5 ? 4 : 6}
          >
            <SubHeading>
              <LayersIcon style={iconStyles} /> Bulk Actions
            </SubHeading>
            <StyledButton
              onClick={queueAllPatrons}
              colour="success"
              margin="0 0 1.8rem 0"
            >
              Queue all
            </StyledButton>
            <StyledButton
              onClick={() => {
                clearOrders();
                close();
              }}
              colour="info"
            >
              Clear Queue
            </StyledButton>
            <Box style={{ marginLeft: "20%" }}>
              <label>
                <Checkbox
                  defaultChecked={FirstTimeOrder}
                  onChange={() => setFirstTimeOrder(!FirstTimeOrder)}
                />
                Queue cards for Students/ Staff without cards
              </label>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={Site.siteType === 0 || Site.siteType === 5 ? 4 : 6}
          >
            <SubHeading>
              <WarningIcon style={iconStyles} /> Danger Zone
            </SubHeading>
            <StyledButton
              disabled={!Site.deleteAll}
              onClick={() => setDeleteModal(true)}
              colour="error"
              margin="0 0 1.8rem 0"
            >
              Delete all
            </StyledButton>

            {Site.siteType === 0 || Site.siteType === 5 ? (
              <StyledButton onClick={() => setIncModal(true)} colour="warning">
                Increment Year Group
              </StyledButton>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Container>

      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <DialogTitle>Wait!</DialogTitle>
        <DialogContent>
          <p style={{ maxWidth: 440, marginBottom: "2rem" }}>
            Are you sure you want to delete all of your {patronLabel} data? This
            will permanently remove all {patronLabel} from your list. If you
            just want to clear the order queue, click the CLEAR QUEUE button.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModal(false)}>Close</Button>
          <Button
            colour="error"
            onClick={() => {
              deleteAllPatrons();
              setDeleteModal(false);
              close();
            }}
          >
            Proceed
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog maxWidth open={IncModal} onClose={() => setIncModal(false)}>
        <DialogTitle>Wait!</DialogTitle>
        <DialogContent>
          <p style={{ maxWidth: 500, marginBottom: "2rem" }}>
            Are you sure you want to Increment all of your yearGroups data? This
            will permanently change all yearGroups from your list.
            <br />
            <br /> <b>Proceed</b> will change year Group 12 to N/A, Kindergarten
            to Pre-primary and Pre-primary to year 1.
            <br />
            <br />
            <b>Proceed & Remove current year 12</b> will remove all yearGroup 12
            students, Kindergarten to Pre-primary and Pre-primary to year 1.
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIncModal(false)}>Close</Button>
          <Button
            colour="error"
            onClick={() => {
              increment();
              setIncModal(false);
              close();
            }}
          >
            Proceed
          </Button>
          <Button
            colour="error"
            onClick={() => {
              var Dlt = 1;
              incrementAndRemove(Dlt);
              setIncModal(false);
              close();
            }}
          >
            Proceed & Remove current year 12
          </Button>
        </DialogActions>
      </Dialog>
    </Dialog>
  );
};

const iconStyles = {
  fontSize: "17px",
};

const Container = styled.div`
  padding: 2rem 4rem;
`;

const StyledButton = styled(Button)`
  width: 100%;
`;

export default BulkActions;
